export default __webpack_public_path__ + "static/media/q-contact.cbc611c1.png";